import { useState, useEffect } from 'react';

const QUERY = '(max-width: 639px)';

/**
 * True when viewport matches Tailwind `sm` breakpoint (mobile-first: below sm).
 */
export function useViewportMobile() {
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : false
    );

    useEffect(() => {
        const mq = window.matchMedia(QUERY);
        const onChange = () => setIsMobile(mq.matches);
        onChange();
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, []);

    return isMobile;
}
